module.exports = __webpack_public_path__ + "static/media/textbook.e2eb0603.png";